export const API_URL = 'https://myanimeflix.herokuapp.com'
// export const API_URL = 'http://localhost:8080'
